export var defaultSystemColor = '#b2b2b2';